import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
export const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

const load = (k, d) => {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch { return d; }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => load("delaboo_cart", []));
  const [mode, setModeState] = useState(() => load("delaboo_mode", "collection"));
  const [postcode, setPostcodeState] = useState(() => load("delaboo_postcode", ""));

  useEffect(() => { localStorage.setItem("delaboo_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("delaboo_mode", JSON.stringify(mode)); }, [mode]);
  useEffect(() => { localStorage.setItem("delaboo_postcode", JSON.stringify(postcode)); }, [postcode]);

  const setMode = (m) => setModeState(m);
  const setPostcode = (p) => setPostcodeState(p);

  const addLine = (item, qty, extras, notes) => {
    const unit = Number(item.price) + extras.reduce((s, e) => s + Number(e.price), 0);
    const lineId = `${item.id}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    setItems((prev) => [...prev, {
      lineId, item_id: item.id, name: item.name, image_url: item.image_url,
      base_price: Number(item.price), qty, extras, notes, unit_price: unit,
    }]);
  };

  const updateLine = (lineId, item, qty, extras, notes) => {
    const unit = Number(item.base_price) + extras.reduce((s, e) => s + Number(e.price), 0);
    setItems((prev) => prev.map((l) => l.lineId === lineId ? { ...l, qty, extras, notes, unit_price: unit } : l));
  };

  const incQty = (lineId) => setItems((prev) => prev.map((l) => l.lineId === lineId ? { ...l, qty: l.qty + 1 } : l));
  const decQty = (lineId) => setItems((prev) => prev.flatMap((l) => {
    if (l.lineId !== lineId) return [l];
    if (l.qty <= 1) return [];
    return [{ ...l, qty: l.qty - 1 }];
  }));
  const removeLine = (lineId) => setItems((prev) => prev.filter((l) => l.lineId !== lineId));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, l) => s + l.unit_price * l.qty, 0);
  const count = items.reduce((s, l) => s + l.qty, 0);

  return (
    <CartContext.Provider value={{
      items, mode, postcode, setMode, setPostcode,
      addLine, updateLine, incQty, decQty, removeLine, clear, subtotal, count,
    }}>
      {children}
    </CartContext.Provider>
  );
}
